import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Choose() {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState('');

  const handleNextClick = () => {
    if (selectedOption === 'Jkusa') {
      navigate('/sign-up');
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <h1 style={{ fontFamily: "Kaushan Script" }} className="text-4xl pb-10">Signup</h1>
      <p className="text-2xl font-bold pb-10">Fill in the below details:</p>
      <select
        value={selectedOption}
        onChange={handleOptionChange}
        className="bg-white border text-lg border-gray-300 text-gray-700 py-3 px-2 pr-20 rounded leading-tight focus:outline-none focus:border-blue-500 mb-6"
      > 
        <option>Select</option>
        <option value="Jkusa">Jkusa</option>
        <option value="Fundilima">Fundilima</option>
        <option value="Zetech">Zetech</option>
        <option value="Chama">Chama</option>
      </select>
      <button onClick={handleNextClick} className="rounded-full py-3 px-14 text-lg font-bold bg-[#0CF84E]">Next</button>
    </div>
  );
}

export default Choose;
